/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

export default {
  name: 'timer',
  relations: {
    belongsTo: {
      // Z důvodů zpětné kompatibility se časovače okazují na PowerTask pomocí
      // pojmenování, které odpovídá staršímu rozhraní Task.
      // Změna pojmenování by vyžadovala migraci dat v LocalStorage.
      powerTask: {
        localField: 'task',
        localKey: 'taskId'
      }
    }
  }
};
